<div class="header">
  <div class="header__left">
    <div class="header__logo-container">
      @if (logoImage) {
        <img [src]="logoImage" alt="Logo" class="header__logo-image" />
      } @else {
        <img src="assets/Inovepic_AuthHub_Logo.png" alt="Inovepic AuthHub" class="header__logo-image" />
      }
    </div>
  </div>
  <div class="header__right">
    <div class="header__user-menu-container">
      <button
        kendoButton
        [look]="'flat'"
        class="header__user-avatar"
        (click)="toggleUserMenu()"
        [svgIcon]="userIconSvg"
        [attr.aria-label]="'User menu'"
      >
        <span class="header__sr-only">Open user menu</span>
      </button>
      @if (showUserMenu) {
        <div class="header__user-menu-popup">
          <ul class="header__menu-list">
            @if (username) {
              <li class="header__menu-item header__menu-item--info">
                <span class="header__menu-username">{{ username }}</span>
              </li>
            }
            <li class="header__menu-item">
              <button type="button" class="header__menu-button" (click)="onLogout()">
                <kendo-svg-icon [icon]="logoutIconSvg" class="header__menu-icon"></kendo-svg-icon>
                Logout
              </button>
            </li>
            <li class="header__menu-item">
              <button type="button" class="header__menu-button" (click)="onChangePassword()">
                <kendo-svg-icon [icon]="lockIconSvg" class="header__menu-icon"></kendo-svg-icon>
                Change Password
              </button>
            </li>
          </ul>
        </div>
      }
    </div>
  </div>
</div>

<app-user-change-password-modal
  [visible]="showChangePasswordModal"
  [selectedUser]="currentUser"
  (saveClicked)="onSaveChangePassword($event)"
  (cancelClicked)="closeChangePasswordModal()"
></app-user-change-password-modal>
